enum ParentshipTypeEnum {
  //None = 0, // This is not a valid ParentshipTypeEnum
  Father = 1,
  Mother = 2,
  Custodian = 3,
}

export default ParentshipTypeEnum;
